import { render, staticRenderFns } from "./approvalModel.vue?vue&type=template&id=8aaa6188&scoped=true"
import script from "./approvalModel.vue?vue&type=script&lang=js"
export * from "./approvalModel.vue?vue&type=script&lang=js"
import style0 from "./approvalModel.vue?vue&type=style&index=0&id=8aaa6188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaa6188",
  null
  
)

export default component.exports